import type { FC } from "react";

import { FormattedPrice } from "@jti/ui";

import styles from "./SummaryCartItemPrice.module.scss";

type SummaryCartItemPriceProps = {
  price: number;
  isFreeTrial: boolean;
  currency: string;
};

export const SummaryCartItemPrice: FC<SummaryCartItemPriceProps> = ({ price, isFreeTrial, currency }) => {
  return (
    <div>
      {!isFreeTrial && (
        <div className={styles.price}>
          <FormattedPrice value={price} currency={currency} />
        </div>
      )}
    </div>
  );
};
